import { GridPaginationModel } from '@mui/x-data-grid-pro';

import { BASE_PAGINATION_MODEL } from './basePaginationModel';

export const INVOICES_DEFAULT_PAGINATION_MODEL: GridPaginationModel = {
	...BASE_PAGINATION_MODEL,
	pageSize: 30,
};
